import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';

import {getComponentProps} from './ExperimentStep.selector';

function mapStateToProps(state, ownProps) {
  return getComponentProps(state, ownProps);
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ExperimentStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.ExperimentStep);
